export default class MobileMenu {
    private $menuwrap: JQuery ;
    private $menu: JQuery ;
    private $back: JQuery ;

    private $categories: JQuery;

    private stack: JQuery[] = [];

    private updateLayout(): void {
        if (this.stack.length) {
            this.$back.show();
        } else {
            this.$back.hide();
        }
    }

    public toggle(): void {
        this.$menu.toggleClass('opened');
        $('body').toggleClass('body--lock');
    }

    private switchToSub($item: JQuery): void {
        const $parent = $item.parent();

        const $others =$('> .menu__item', $parent).not($item);

        setTimeout(() => {
            $others.hide();
        }, 300);

        $item.addClass('menu__item--opened');
        this.updateLayout();
    }

    private returnToParent($item: JQuery): void {
        const $parent = $item.parent();

        console.log($parent);

        const $others =$('> .menu__item', $parent).not($item);
        $others.show();

        $item.removeClass('menu__item--opened');
        this.updateLayout();
    }

    private initMobileMenu(): void {
        this.$menu = $('.mobilemenu', this.$menuwrap);
        this.$categories = $('.mobilemenu__categories', this.$menuwrap);

        this.$back = $('.mobilemenu__back', this.$menu);

        const $close = $('.mobilemenu__close', this.$menu);
        const $menu = $('.menu', this.$menu);

        new (<any> window).BluMenu($menu, {
            events: false,
        });

        (<any> window).Site.discover(this.$menu);

        $('.menu__item--children', $menu).each((ix, item) => {
            const $item = $(item);
            const $head = $('> .menu__head', $item);
            const $sub = $('> .menu__list', $item);

            const $title = $(`
                <li class="menu__item menu__sub-title">
                    ` + $head.text() + `
                </li>
            `);

            $title.prependTo($sub);

            $head.on('click', (e) => {
                e.preventDefault();

                this.stack.push($item);
                this.switchToSub($item);
            });
        });

        $close.on('click', (e) => {
            this.toggle();
        });

        const $iproducts = $('.menu__item--products', $menu);

        $iproducts.on('click', (e) => {
            e.preventDefault();

            this.$menu.addClass('mobilemenu--opened-categories');
            this.$back.show();
        });

        this.$back.click('on', (e) => {
            if (this.$menu.hasClass('mobilemenu--opened-categories')) {
                this.$menu.removeClass('mobilemenu--opened-categories');
                this.$back.hide();
            } else {
                const $popped = this.stack.pop();

                this.returnToParent($popped);
            }
        });

        this.updateLayout();
    }

    public initHtml() {
        const $button = $('.header__bigmenu button');

        $button.on('click', (e) => {
            if (this.$menuwrap == null) {
                this.$menuwrap = $(`<div class="bigmenu-wrapper">`);

                $.ajax({
                    url: '/mobilemenu',
                    method: 'get',

                    success: (r) => {
                        this.$menuwrap.html(r);

                        this.initMobileMenu();

                        this.$menu[0].offsetHeight;

                        this.toggle();
                    },
                })

                $('body').append(this.$menuwrap);
            } else {
                this.toggle();
            }
        });
    }
}
